import React from 'react';
import { useLocation } from 'react-router-dom';
import { getPrimaryAppUrl } from '@/utils/demoHostRedirect';

/**
 * Keeps authentication and organizer screens off the read-only demo host.
 * Public demo pages remain untouched; only routes explicitly wrapped in App
 * use this redirect.
 */
export default function ApexHostOnly({ children }: { children: React.ReactNode }) {
  const routeLocation = useLocation();
  const destination = typeof window === 'undefined'
    ? null
    : getPrimaryAppUrl(window.location);

  React.useEffect(() => {
    if (destination) window.location.replace(destination);
  }, [destination, routeLocation.key]);

  if (destination) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return <>{children}</>;
}
